import template from './exportRequest.template.html';
import templateAccessHistory from './exportAccessHistory.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $timeout,
  $mdDialog,
  $location,
  webpage,
  dateTimeService,
  exportService,
  accountsService,
  navigationService,
  authenticationService,
  uiService,
  EXPORT,
  ACCOUNT
) => {
  /*
   * Controller Model
   * --------------------------------------------------------------------------------
   */
  $scope.Model = {
    availableExports: [],
    queuedExport: null,
    isReady: false
  };

  /*
   * Controller Scope Events
   * --------------------------------------------------------------------------------
   */
  $scope.$on('exportData', ($event) => {
    function showRequestController() {
      this.isReady = false;
      this.idAccount = undefined;
      Promise.all([
        accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST }),
        accountsService.getAvailable({ isActive: false, fields: ACCOUNT.FIELDS.LIST })
      ]).then((res) => {
        this.accounts = [].concat(res[0]).concat(res[1]);
        this.isReady = true;
      });
      this.confirm = () => $mdDialog.hide(this.idAccount);
      this.cancel = () => $mdDialog.cancel();
    }

    $mdDialog
      .show({
        targetEvent: $event,
        template,
        controllerAs: '$ctrl',
        controller: showRequestController
      })
      .then((res) => {
        exportService.create({ idRequestedAccount: res }).then((r) => {
          if (r && r.status) {
            uiService.toast({
              text: {
                p1: 'Data export request',
                p2: 'created',
                p3: 'successfully'
              },
              warn: false
            });
            exportService.clearCache();
            navigationService.organizationChange({
              idOrganization: $rootScope.CurrentOrganization.id,
              url: $location.absUrl()
            });
          } else {
            uiService.toast({
              text: {
                p1: 'Failed to',
                p2: 'create',
                p3: 'data export request'
              },
              warn: true
            });
          }
        });
      });
  });

  /*
   * Controller Initialization
   * --------------------------------------------------------------------------------
   */
  $scope.isHelpDesk = () =>
    String($rootScope.CurrentAccount.getEmail()).trim() === 'helpdesk@salestrekker.com';

  const init = () => {
    if (authenticationService.isOwner() || $scope.isHelpDesk()) {
      Promise.all([
        exportService.getAvailable({ fields: EXPORT.FIELDS.LIST }),
        exportService.getAvailable({ fields: EXPORT.FIELDS.LIST, isActive: false }),
        exportService.getQueue()
      ])
        .then((res) => {
          $scope.Model.availableExports = _.sortBy(
            [].concat(res[0], res[1]),
            'timeStamp'
          ).reverse();
          if (res[2]?.status && res[2]?.id) {
            $scope.queuedExport = res[2].id;
          }
        })
        .then(() => {
          webpage.pageTitle('Export : Settings');
          $scope.Model.isReady = true;
        });
    }
  };

  /*
   * Controller Scope Functions
   * --------------------------------------------------------------------------------
   */
  $scope.isOwner = () => authenticationService.isOwner();
  $scope.getDate = (timeStamp) => dateTimeService.getFormattedDateTime(timeStamp);
  $scope.download = ($event, ex) => {
    exportService.downloadUrl({ id: ex.id }).then(() => {
      $scope.Model.isReady = true;
      exportService.clearCache();
      init();
    });
  };
  $scope.showAccessHistory = ($event, ah) => {
    $event.stopPropagation();
    function showAccessHistoryController() {
      this.accessHistory = ah;
      this.getDate = (timeStamp) => dateTimeService.getFormattedDateTime(timeStamp);
      this.confirm = () => $mdDialog.cancel();
      this.cancel = () => $mdDialog.cancel();
    }

    if (ah) {
      $mdDialog.show({
        targetEvent: $event,
        template: templateAccessHistory,
        controllerAs: '$ctrl',
        controller: showAccessHistoryController
      });
    }
  };

  webpage.pageTitle('Loading, please wait');
  init();
};
